import * as yup from 'yup'
import { INVALID_PRICE_FORMAT } from 'constants/errors'
import { priceReg } from 'constants/regExp'

export const schemaSetDefault = yup.object().shape({
  vendorIds: yup.string(),
  defaultFee: yup.string().matches(priceReg, INVALID_PRICE_FORMAT),
})
